export function toBr (date) {
  if (date instanceof Date) return toBrDate(date)

  if (typeof date === 'string') return toBrString(date)

  return date
}

// Protected Functions

function toBrString (date) {
  if (date.includes('/')) return date

  return date.split('-').reverse().join('/')
}

function toBrDate (date) {
  let year = date.getFullYear()
  let month = (date.getMonth() + 1)
  let day = date.getDate()

  if (month < 10) month = '0' + month;

  return day + '/' + month + '/' + year
}